import {
  ADVANCED_TRADING_REQUEST_ELIGIBILITY_DESER,
  AdvancedTradingRequestEligibility,
  ENABLEMENTS_DESER,
  Enablements,
  type EnablementTypes,
} from "../../tastyworks"
import type HttpClient from "../../tastyworks/http"

export class AccountOpeningApplicationEnablementsService {
  private readonly applicationClient: HttpClient

  constructor(private readonly baseClient: HttpClient) {
    this.applicationClient = this.baseClient.nested(
      "account-opening-applications"
    )
  }

  // Currently this endpoint returns an AdvancedTradingRequestEligibility with the
  // same [reasons as other advanced trading requests](https://tinyurl.com/nhh77e5r),
  // if this changes in the future then a specific model may be required
  readonly showEligibility = async (
    applicationId: string,
    enablementType: EnablementTypes
  ) =>
    this.applicationClient.show(
      new AdvancedTradingRequestEligibility(),
      ADVANCED_TRADING_REQUEST_ELIGIBILITY_DESER.update,
      "/:applicationId/enablements/eligibility",
      { applicationId, enablementType }
    )

  readonly create = async (
    enablements: Enablements,
    accountOpeningApplicationId: string
  ) =>
    this.applicationClient.create(
      enablements,
      ENABLEMENTS_DESER.serialize,
      ENABLEMENTS_DESER.update,
      "/:accountOpeningApplicationId/enablements",
      { accountOpeningApplicationId }
    )
}
